<template>
  <div class="legend">
    <div class="label-row">
      <p
        v-for="label in labels"
        :key="label"
        class="label-text"
      >
        {{ label }}
      </p>
    </div>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 274 4"
    >
      <rect
        v-for="(color, i) in colors"
        :key="color"
        :x="(274/colors.length)*i"
        :style="`fill:${color}; width:${(278/colors.length)}px;`"
      />
    </svg>
  </div>
</template>

<script>
export default {
  name: 'HorizontalLegend',
  props: {
    labels: {
      type: Array,
      required: true,
    },
    colors: {
      type: Array,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.legend {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
  margin-bottom: 0.5rem;
}
.label-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 1.25rem;
}
.label-text {
  font-size: 15px;
  color: #405966;
}
rect {height: 5px; width: calc(101%/9);}
</style>
